import _ from "lodash"

import { _getGlobal, _setGlobal, API } from '@utils'
import { uuidv4 } from "@csrc/utility/Utils"

import { SendDropItemToFlutterApp, SendSelectItemToFlutterApp } from "@csrc/utility/FlutterWebMiddleware"
import {
  syncRelations
} from "../../utility/templateBuilderContext-new"
import { AI_API } from "../../utility/AI_API"
import { CHECKLIST_STORE_ACTION_TYPES } from "../reducers/actions"

//******************  ******************//
export function _getTemplatesList({ limit, page, sort, filter }, callback) {
  API.get('/checklist/template/list', {
    params: {
      limit,
      page,
      sort,
      filter
    }
  })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
export function _getTemplatesOptions(templateId, callback) {
  API.get(`/checklist/template/${templateId}/options`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
export function _setTemplatePrimaryLang(templateId, lang, callback) {
  API.post(`/checklist/template/${templateId}/set-language`, { lang })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
export function _addTemplateTranslationLang(templateId, lang, callback) {
  API.post(`/checklist/template/${templateId}/translation/add`, { lang })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
export function _removeTemplateTranslationLang(templateId, lang, callback = () => { }, callbackErr = () => { }, callbackFinish = () => { }) {
  API.delete(`/checklist/template/${templateId}/translation/${lang}`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
    .finally(callbackFinish)
}
//******************  ******************//
export function _getTranslationsLang(templateId, lang, callback) {
  API.get(`/checklist/template/${templateId}/translation/${lang}`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
/**
 * Promise based variant of `_getTranslationsLang`, used when the translations of several
 * languages have to be read in one go (see utility/response-options/option-uuid-refresh).
 * Runs silently, it is a background read the user did not ask for.
 */
export function _getTranslationsLangAsync(templateId, lang, keys) {
  const params = {}
  if (keys) {
    params.keys = keys
  }
  return API.get(`/checklist/template/${templateId}/translation/${lang}`, { silent: true, params })
    .then(function ({ data }) {
      return data
    })
}
//******************  ******************//
export function _setItemTranslation(templateId, lang, data, callback) {
  API.put(`/checklist/template/${templateId}/translation/${lang}`, data)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
export function _setBulkItemsTranslation(templateId, lang, data, callback) {
  API.put(`/checklist/template/${templateId}/translation/${lang}/bulk-update`, data)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
/**
 * Promise based variant of `_setBulkItemsTranslation`, see `_getTranslationsLangAsync`.
 */
export function _setBulkItemsTranslationAsync(templateId, lang, data) {
  return API.put(`/checklist/template/${templateId}/translation/${lang}/bulk-update`, data, { silent: true })
    .then(function ({ data }) {
      return data
    })
}
//******************  ******************//
export function _setBulkItemsAutoTranslation(templateId, lang, data, callback) {
  API.put(`/checklist/template/${templateId}/translation/${lang}/bulk-auto-translate`, data)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
export function _setBulkItemsAutoTranslationWithAI(templateId, data, callback) {
  AI_API.post(`/translate`, data)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
export function _setGlobalResponseTranslation(id, data, callback) {
  API.put(`/checklist/global-response/options/${id}/translate`, {
    lang: data.lang,
    translation: data.translation
  })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
export const _translateGlobalResponse = (globalResponseUuid, { lang, options }, callback, callbackErr) => {
  API.put(`/checklist/global-response/${globalResponseUuid}/${lang}`, {
    options
  }, { silent: true })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
      if (callbackErr) {
        callbackErr(data.data)
      }
    })
}
//******************  ******************//
export function _setTemplateInfoWithOptions(id, data, callback, callbackError) {
  return API.get(`/checklist/template/${id}`, {
    params: data
  })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(callbackError)
}
//******************  ******************//
export function _publishTemplate(id, callback, callbackError) {
  const revision = _getGlobal('ckl_revision')
  API.post(`/checklist/template/${id}/publish`, { revision })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(callbackError)
}
//******************  ******************//
export function _addFolder(data, callback) {
  API.post('/checklist/template/folder/new', data)
    .then(function ({ data }) {
      callback(data)
    })
}
//******************  ******************//
export function _editFolder(id, data, callback) {
  API.put(`/checklist/template/folder/${id}`, data)
    .then(function ({ data }) {
      callback(data)
    })
}
//******************  ******************//
export function _deleteFolder(id, callback, callbackErr) {
  API.delete(`/checklist/template/folder/${id}`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(callbackErr)
}
//******************  ******************//
export function _archiveTemplate(id, callback) {
  API.delete(`/checklist/template/${id}`)
    .then(function ({ data }) {
      callback(data)
    })
}
//******************  ******************//
export function _addNewStructure(callback) {
  API.post('/checklist/structure/new')
    .then(function ({ data }) {
      callback(data)
    })
}
//******************  ******************//
export function _editPageTitle(id, title, callback) {
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_EDIT_PAGE_TITLE, payload: { id, title } })
    API.post(`/checklist/template/${id}`, {})
      .then(function ({ data }) {

      })
  }
}
//******************  ******************//
export function _getAllFolders(callback, callbackErr, excludeId) {
  const data = {
    params: {}
  }
  if (excludeId) {
    data.params.exclude_id = excludeId
  }
  API.get(`/checklist/template/folder/all`, data)
    .then(function ({ data }) {
      callback(data)
    }).catch(callbackErr)
}
//******************  ******************//
export function _moveTemplate(id, parent_id, callback, callbackErr) {
  API.post(`checklist/template/move`, { id, parent_id: parseInt(parent_id) })
    .then(function ({ data }) {
      callback(data)
    }).catch(callbackErr)
}
//******************  ******************//
export function _cloneTemplate(templateId, parent_id, callback, callbackErr) {
  API.post(`checklist/template/${templateId}/clone`, { parent_id })
    .then(function ({ data }) {
      callback(data)
    }).catch(callbackErr)
}
//******************  ******************//
export function setSelectedItem(item) {
  SendSelectItemToFlutterApp(item)
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_SET_SELECTED_ITEM, payload: item })
  }
}
//******************  ******************//
export function setSelectedSubItem(item, callStack) {
  // SendSelectItemToFlutterApp(item)
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_SET_SELECTED_SUB_ITEM, payload: { item, callStack } })
  }
}
//******************  ******************//
export function _setSingleToMultipleSelectedItems(item) {
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_SET_SINGLE_TO_MULTIPLE_SELECTED_ITEMS, payload: item })
  }
}
//******************  ******************//
export function _setItemsToTranslationMultipleSelectedItems(itemsId) {
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_SET_ITEMS_TO_TRANSLATION_MULTIPLE_SELECTED_ITEMS, payload: itemsId })
  }
}
//******************  ******************//
export function _setMultipleToMultipleSelectedItems(items) {
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_SET_MULTI_TO_MULTIPLE_SELECTED_ITEMS, payload: items })
  }
}
//******************  ******************//
export function _toggleMultiSelectMode(enable) {
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_TOGGLE_MULTI_SELECT_MODE, payload: enable })
  }
}
//******************  ******************//
export function _toggleTranslationMultiSelectMode(enable) {
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_TOGGLE_TRANSLATION_MULTI_SELECT_MODE, payload: enable })
  }
}
//******************  ******************//
export function _emptyMultipleSelectedItems() {
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_EMPTY_MULTI_SELECT_ITEMS })
  }
}
//******************  ******************//
export function _emptyTranslationMultipleSelectedItems() {
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_EMPTY_TRANSLATION_MULTI_SELECT_ITEMS })
  }
}
//******************  ******************//
export function _copySelectedItemsToClipboard(items) {
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_COPY_SELECTED_ITEMS_TO_CLIPBOARD })
  }
}
//******************  ******************//
export function _savePastItems(data) {
  return dispatch => {
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_SAVE_PAST_ITEMS, payload: data })
  }
}
//******************  ******************//
export function _sendCopiedData(templateId, data, callback = (data) => { }) {
  if (_.size(data.rules) > 0 || _.size(data.image_markers) > 0 || _.size(data.grouped_items) > 0) {
    API.post(`checklist/template/${templateId}/past-items`, data)
      .then(function ({ data }) {
        callback(data)
      })
  } else {
    callback(null)
  }
}
//******************  ******************//
export function _sendEditRequest(template_id, data, callbackErr) {
  data = { ...data }
  const _revision = _getGlobal('ckl_revision')

  if (_revision) { // for first update
    data.revision = _revision
  }
  if (data.revision !== _getGlobal('ckl_revisionLastSent')) {
    _setGlobal('ckl_revisionLastSent', data.revision)
    data.contains_asset = !!_.find(data.items, item => {
      return item.type === 'asset'
    })
    API.post(`/checklist/template/${template_id}`, data, { synchronous: false })
      .then(function ({ data }) {
        // dispatch({type: "CLK_TEMPLATE_UPDATE_REVISION_KEY", payload: data})
        _setGlobal('ckl_revision', data.revision)
      })
      .catch(callbackErr)
  } else {
    _setGlobal('ckl_editTemplateQ', data)

    setTimeout(() => {
      const dataQ = _getGlobal('ckl_editTemplateQ')
      if (dataQ) {
        _setGlobal(_setGlobal('ckl_editTemplateQ', false))
        _sendEditRequest(template_id, data)
      }

    }, 1000)
  }

}
//******************  ******************//
export function _addNewResponseSet(templateId, { data }, callback = () => { }) {
  // console.log('data', data)
  return dispatch => {
    if (_.size(data.options.responses) > 0) {
      const response_set = {
        uuid: uuidv4(),
        options: data.options.responses.filter(x => x.label || x.label?.length > 0)
      }
      if (_.size(response_set.options) <= 0) {
        return
      }
      dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CKL_ADD_RESPONSE_SET, payload: response_set })
      API.post(`checklist/template/${templateId}/response/new`, response_set)
        .then(function () {
          delete data.options.responses
          data.options.response_set_id = response_set.uuid
          // data.options.enable_score = data.enable_score
          // data.options = {response_set_id:response_set.uuid, required: data.options.required}
          callback(data)
        })
    }
  }
}
//******************  ******************//
export function _linkWithGlobalResponseSet(templateId, { data }, callback = () => { }) {
  // console.log('data', data)
  return dispatch => {
    if (_.size(data.options.responses) > 0) {
      const response_set = {
        uuid: uuidv4(),
        options: data.options.responses
      }
      API.post(`checklist/template/${templateId}/response/new`, response_set)
        .then(function (res) {
          dispatch({
            type: CHECKLIST_STORE_ACTION_TYPES.CKL_ADD_RESPONSE_SET,
            payload: {
              uuid: response_set.uuid,
              options: res.data.options
            }
          })
          delete data.options.responses
          data.options.response_set_id = response_set.uuid
          // data.options.enable_score = data.enable_score
          // data.options = {response_set_id:response_set.uuid, required: data.options.required}
          callback(data)
        })
    }
  }
}
//******************  ******************//
export function _addNewGroupOptions(templateId, data, callback = () => { }) {
  return dispatch => {
    API.post(`checklist/template/${templateId}/grouped-item/new`, data)
      .then(function ({ data }) {
        dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CKL_ADD_GROUPED_ITEM, payload: data.data })
        callback(data.grouped_item_id)
      })
  }
}
//******************  ******************//
export function _addNewRuleSetOptions(templateId, data, callback = () => { }) {
  return dispatch => {
    API.post(`checklist/template/${templateId}/rules/new`, { ...data, uuid: uuidv4() })
      .then(function ({ data }) {
        dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CKL_ADD_RULE_SET, payload: data })
        callback(data.uuid)
      })
  }
}
//******************  ******************//
/**
 * Promise based variant of `_addNewRuleSetOptions`, used when several rule sets have to be
 * recreated at once (see utility/response-options/option-uuid-refresh). Rule sets are immutable
 * server side, every save creates a new one, so the caller is responsible for syncing the store
 * and for re-pointing `options.rule_set_id` of the owning items.
 */
export function _addNewRuleSetOptionsAsync(templateId, data) {
  return API.post(`checklist/template/${templateId}/rules/new`, { ...data, uuid: uuidv4() })
    .then(function ({ data }) {
      return data
    })
}
//******************  ******************//
export function _addNewInfo(templateId, items, callback = () => { }) {
  return dispatch => {
    const Info = {
      uuid: uuidv4(),
      items
    }
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CKL_ADD_INFO, payload: Info })
    API.post(`checklist/template/${templateId}/info/new`, Info)
      .then(function () {
        callback(Info.uuid)
      })
  }
}
//******************  ******************//
export function _addNewImageMarker(templateId, imageMarker, callback = () => { }) {
  return dispatch => {
    const imageMarkerData = {
      uuid: uuidv4(),
      ...imageMarker
    }
    API.post(`checklist/template/${templateId}/image-marker/new`, imageMarkerData)
      .then(function ({ data }) {
        imageMarkerData.file = data.file
        dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CKL_ADD_IMAGE_MARKER, payload: imageMarkerData })
        callback(imageMarkerData.uuid)
      })
  }
}
//******************  ******************//
export function _undoTemplate(template, callback = () => { }) {
  const tempState = { ...template }
  const lastUpdate = tempState.past[tempState.past.length - 1]
  tempState.past.pop()
  const present = {
    ...lastUpdate,
    revision: tempState.present.revision
  }
  tempState.future.push(tempState.present)
  tempState.present = present
  tempState.relations = syncRelations(tempState)
  return dispatch => {
    SendDropItemToFlutterApp(tempState.present)
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_UNDO, payload: tempState })
    _sendEditRequest(tempState.present.template_id, tempState.present)
    callback()
  }
}
//******************  ******************//
export function _reduTemplate(template, callback = () => { }) {
  const tempState = { ...template }
  const revision = tempState.present.revision
  tempState.past.push(tempState.present)
  tempState.present = {
    ...tempState.future[tempState.future.length - 1],
    revision
  }
  tempState.future.pop()
  tempState.relations = syncRelations(tempState)
  return dispatch => {
    SendDropItemToFlutterApp(tempState.present)
    dispatch({ type: CHECKLIST_STORE_ACTION_TYPES.CLK_TEMPLATE_REDO, payload: tempState })
    _sendEditRequest(tempState.present.template_id, tempState.present)
    callback()
  }
}
//******************  ******************//
export const _toggleHidePages = () => {
  return dispatch => {
    dispatch({ type: "CKL_TOGGLE_HIDE_PAGES" })
  }
}
//******************  ******************//
export const _getCategories = (callback) => {
  API.get('/issue/category/all').then(({ data }) => {
    callback(data)
  })
}
//******************  ******************//
export const _searchTemplate = async ({ q = '', parentId = '', ids = [] } = {}) => {
  return await API.get('/checklist/template/search', {
    params: {
      q,
      parent_id: parentId,
      ids
    }
  })
    .catch(function (res) { })
}
//******************  ******************//
export const _searchChecklist = async ({ q = '' }) => {
  return await API.get(`checklist/search`, {
    params: {
      q,
      limit: 10
    }
  })
    .catch(function (res) { })
}
//******************  ******************//
export const _searchSites = async ({ q = '', parentId = '', ids = [] } = {}) => {
  return await API.get(`/resources/sites/search`, {
    params: {
      q,
      parent_id: parentId,
      ids
    }
  })
    .catch(function (res) { })
}
//******************  ******************//
export function _getYesNoLists(callback, passedData) {
  API.get('/checklist/global-response/list', {
    params: passedData
  })
    .then(function ({ data }) {
      if (passedData.list) {
        callback({
          list: data,
          pagination: {
            current_page: 1,
            limit: 0,
            total: 0,
            total_pages: 0
          }
        })
      } else {
        callback(data)
      }
    })
    .catch(function (res) { })
}
//******************  ******************//
export function _getCustomUnitsLists(callback) {
  API.get('/checklist/custom-units/all')
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
export function _addNewCustomUnit(data, callback, callbackError) {
  API.post('/checklist/custom-units/new', data)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(callbackError)
}
//******************  ******************//
export function _addNewGlobalResponse(data, callback, callbackErr) {
  API.post(`/checklist/global-response/new`, data, { silent: true })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
      if (callbackErr) {
        callbackErr(data.data)
      }
    })
}
//******************  ******************//
export function _editGlobalResponse(globalResponseUuid, data, callback, callbackErr) {
  API.put(`/checklist/global-response/${globalResponseUuid}`, data, { silent: true })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
      if (callbackErr) {
        callbackErr(data.data)
      }
    })
}
//******************  ******************//
export function _delGlobalResponse(globalResponseUuid, callback) {
  API.delete(`/checklist/global-response/${globalResponseUuid}`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
export function _sendTranslationFile(templateId, lang_to, data, callback = () => { }, callbackErr = () => { }, finishCallback = () => { }) {
  const formData = new FormData()
  formData.append('file', data.file)
  // formData.append('columns', JSON.stringify(data.columns))
  _.forEach(data.columns, (val, key) => {
    formData.append(key, val)
  })
  API.post(`/checklist/template/${templateId}/translation/${lang_to}/import`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function ({ data }) {
      callbackErr(data)
    })
    .finally(() => finishCallback())
}
//******************  ******************//
export function _getChecklistItems(templateId, callback) {
  API.get(`/checklist/${templateId}/last-version-items`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
//******************  ******************//
export function _getRatingsList(callback, preferred_lang = '') {
  API.get('/checklist/settings/ratings', { params: { preferred_lang } })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (res) { })
}
